import { render, staticRenderFns } from "./mix-table-block.v2.vue?vue&type=template&id=4c20930e"
import script from "./mix-table-block.v2.vue?vue&type=script&setup=true&lang=js"
export * from "./mix-table-block.v2.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports